// Export and run the CLI directly
export * from './bin';
import { program } from './bin';

// Parse arguments if this is the main module
if (require.main === module) {
  program.parse(process.argv);
}